var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useDebounce } from "use-debounce";
import { useHistory, useLocation } from "react-router-dom";
var storageKey = "admin-playlists-search";
var getInitialSearchParams = function (search) {
    var _a;
    var storedSearch = (_a = window.sessionStorage.getItem(storageKey)) !== null && _a !== void 0 ? _a : "";
    return new URLSearchParams(search || storedSearch);
};
var getInitialType = function (params) {
    var type = params.get("type");
    return type === "private" || type === "public" || type === "any"
        ? type
        : "public";
};
var getInitialClientId = function (params) {
    var id = Number(params.get("clientId"));
    return Number.isFinite(id) && id > 0 ? id : null;
};
export var useSearchPlaylistForm = function () {
    var _a, _b, _c;
    var history = useHistory();
    var location = useLocation();
    var initialParams = React.useMemo(function () { return getInitialSearchParams(location.search); }, []);
    var _d = React.useState((_a = initialParams.get("title")) !== null && _a !== void 0 ? _a : ""), title = _d[0], setTitle = _d[1];
    var _e = React.useState({
        type: getInitialType(initialParams),
        id: getInitialClientId(initialParams),
    }), client = _e[0], setClient = _e[1];
    var _f = React.useState((_b = initialParams.get("orderBy")) !== null && _b !== void 0 ? _b : "order"), orderBy = _f[0], setOrderBy = _f[1];
    var _g = React.useState((_c = initialParams.get("orderByDirection")) !== null && _c !== void 0 ? _c : "asc"), orderByDirection = _g[0], setOrderByDirection = _g[1];
    var playlistTitle = useDebounce(title, 1000)[0];
    React.useEffect(function () {
        var params = new URLSearchParams();
        params.set("type", client.type);
        if (client.id) {
            params.set("clientId", String(client.id));
        }
        if (playlistTitle) {
            params.set("title", playlistTitle);
        }
        if (orderBy) {
            params.set("orderBy", orderBy);
        }
        if (orderByDirection) {
            params.set("orderByDirection", orderByDirection);
        }
        var search = "?" + params.toString();
        window.sessionStorage.setItem(storageKey, search);
        if (location.search !== search) {
            history.replace({ pathname: location.pathname, search: search });
        }
    }, [
        client.id,
        client.type,
        history,
        location.pathname,
        location.search,
        orderBy,
        orderByDirection,
        playlistTitle,
    ]);
    var changeTitle = function (evt) {
        return setTitle(evt.target.value);
    };
    var changeType = function (evt) {
        var value = evt.target.value;
        if (value === "public" || value === "any") {
            setClient({ id: null, type: value });
            setOrderBy('order');
            setOrderByDirection('asc');
        }
        else if (value === "private") {
            setClient(__assign(__assign({}, client), { type: value }));
            setOrderBy('updated_at');
            setOrderByDirection('desc');
        }
        else {
            setClient({ id: null, type: "any" });
        }
    };
    var changeClient = function (payload) {
        var _a;
        setClient(__assign(__assign({}, client), { id: (_a = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _a !== void 0 ? _a : null }));
    };
    var form = {
        title: playlistTitle,
        type: client.type,
        clientId: client.id,
        orderBy: orderBy,
        orderByDirection: orderByDirection
    };
    var showClientField = client.type === "private";
    return {
        form: form,
        title: { value: title, onChange: changeTitle },
        type: { value: client.type, onChange: changeType },
        client: { value: client.id, onChange: changeClient },
        showClientField: showClientField,
    };
};
